import { TableState } from '@optimus-web/core';
import {
    CancellationPolicyOverviewEntry,
    useRepositoryMutation,
    useRepositoryQuery,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export const useCancellationPoliciesGetOverviewEntriesQuery = (
    tableState: TableState<CancellationPolicyOverviewEntry>
) => useRepositoryQuery('cancellationPolicies', 'getOverviewEntries', tableState);

export const useCancellationPolicyGetQuery = (cancellationPolicyId?: string) =>
    useRepositoryQuery(
        'cancellationPolicies',
        'getAll',
        {
            ids: cancellationPolicyId ? [cancellationPolicyId] : [],
            extent: {
                rateGroups: true,
            },
        },
        {
            select: (cancellationPolicies) => cancellationPolicies.find(({ id }) => id === cancellationPolicyId),
            enabled: !!cancellationPolicyId,
        }
    );

export const useCancellationPolicyGetSuspenseQuery = (cancellationPolicyId: string) =>
    useRepositorySuspenseQuery(
        'cancellationPolicies',
        'getAll',
        { ids: cancellationPolicyId ? [cancellationPolicyId] : [] },
        {
            select: (cancellationPolicies) => cancellationPolicies.find(({ id }) => id === cancellationPolicyId),
            gcTime: 0,
        }
    );

export const useCreateCancellationPolicy = () =>
    useRepositoryMutation('cancellationPolicies', 'add', {
        invalidateQueries: {
            cancellationPolicies: ['getAll', 'getOverviewEntries'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('CancellationPolicyCreateSuccessMessage'),
            });
        },
    });

export const useCancellationPolicyUpdateMutation = () =>
    useRepositoryMutation('cancellationPolicies', 'update', {
        invalidateQueries: {
            cancellationPolicies: ['getAll', 'getOverviewEntries'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('CancellationPolicyUpdateSuccessMessage'),
            });
        },
    });

export const useCancellationPolicyDeleteMutation = () =>
    useRepositoryMutation('cancellationPolicies', 'delete', {
        invalidateQueries: {
            cancellationPolicies: ['getAll', 'getOverviewEntries'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('CancellationPolicyDeleteSuccessMessage'),
            });
        },
    });
